import React from "react";
import { hexToRgba } from "../../../services/helpFunctions/hexToRgba";

// Fallback when a facility has no colour, or an old free-text value that isn't a
// valid hex — so the tag always renders as a readable box.
const DEFAULT_COLOR = "#6A113C";

// Pull a #rgb / #rrggbb out of the stored value (tolerates "var(--x, #hex)").
export const normalizeFacilityColor = (c) => {
  const m = /#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})/.exec(c || "");
  return m ? m[0] : DEFAULT_COLOR;
};

// Facility rendered as a tinted "box": the facility's (dark) colour as the text
// on a light tint of that same colour — matching the platform's status pills so
// the Facility column reads consistently across every site-visit table.
//
// Accepts either a `facility` object ({ name, color }) or explicit name/color.
const FacilityTag = ({ facility, name, color, style }) => {
  const label = facility?.name ?? name;
  if (!label) return null;
  const hex = normalizeFacilityColor(facility?.color ?? color);
  return (
    <span
      className="facilityTag"
      title={label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        maxWidth: "100%",
        padding: "3px 10px",
        borderRadius: 16,
        fontFamily: "Poppins, sans-serif",
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.6,
        color: hex,
        background: hexToRgba(hex, 0.12),
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        ...style,
      }}
    >
      {label}
    </span>
  );
};

export default FacilityTag;
